import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { connect, useDispatch } from "react-redux";
import { setApiError } from "../dashboard/actions";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import styles from './authorization.css';
import { isEmpty, isNil, propOr } from "ramda";

const Authorization = ({apiError}) => {
  const dispatch = useDispatch();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [titleMessage, setTitleMessage] = useState("");
  const [bodyMessage, setBodyMessage] = useState("");
  const [okBtn, setOkBtn] = useState("");
  const [cancelBtn, setCancelButton] = useState("Cancel");

  const handleOnClose = () => {
    setIsOpenModal(false);
    dispatch(setApiError(null));
  };

  useEffect(() => {
    if (isNil(apiError)) return;

    switch (apiError.errorCode) {
      case 402: {
        setTitleMessage("Sorry, not enough credits");
        setBodyMessage(
          <div>
            Sorry but it looks like you ran out of credits for PDF.co. To add
            credits please use{" "}
            <a href="https://app.pdf.co/subscriptions" target="_blank">
              this page
            </a>
            .
          </div>
        );
        setOkBtn(
          <a href="https://app.pdf.co/subscriptions" target="_blank">
            <button
              className={classNames(
                "btn btn-primary OpenCreditsPageBtn",
              )}
            >
              Open Credits Page
            </button>
          </a>
        );
        setCancelButton("Cancel");
        setIsOpenModal(true);
        break;
      }

      case 401:
      case 403: {
        setTitleMessage("Sorry, the UI session has expired");
        setBodyMessage(
          <div>
            Sorry, your UI session has expired. Please refresh the page to
            re-initiate the session
          </div>
        );
        setOkBtn(
          <button
            className={classNames(
              "btn btn-primary OpenCreditsPageBtn",
            )}
            onClick={() => {
              window.location.reload();
              handleOnClose();
            }}
          >
            Refresh
          </button>
        );
        setCancelButton("Cancel");
        setIsOpenModal(true);
        break;
      }

      default: {
        const responseMessage = propOr("", 'message', apiError);
        setTitleMessage("An error occurred while processing your request!");
        setBodyMessage(
          <div>
            {isEmpty(responseMessage) ? "An unexpected error occurred! Please try again!" : responseMessage}

            <div className={"small mt-3"}>
              <a href="https://app.pdf.co/logs/api">Check API logs for details</a>
            </div>
            <div className={"small"}>
              <a href="https://apidocs.pdf.co/kb">Explore PDF.co Knowledgebase</a>
            </div >
            <div className={"small"}>
              <a href={`https://support.bytescout.com/hc/en-us/requests/new?subject=Document%20Parser%20Template%20Editor%20${responseMessage}`}>Contact Customer Support</a>
            </div>
          </div>
        );
        setOkBtn(
          <button
            className={classNames(
              "btn btn-primary OpenCreditsPageBtn",
            )}
            onClick={() => {
              window.location.reload();
              handleOnClose();
            }}
          >
            Refresh
          </button>
        );
        setCancelButton("Close");
        setIsOpenModal(true);
        break;
      }
    }
  }, [apiError]);

  return (
    <div>
      <Modal show={isOpenModal} onHide={() => setIsOpenModal(false)}>
        <Modal.Header>
          <div className="ContentWrap">
            <div className="IconWrap">
              <FontAwesomeIcon
                icon={faExclamationCircle}
                className="text-danger"
              />
            </div>
            <div className="Title">{titleMessage}</div>
          </div>
        </Modal.Header>
        <Modal.Body>{bodyMessage}</Modal.Body>
        <Modal.Footer>
          {okBtn}
          <button
            className="btn btn-outline-secondary"
            onClick={handleOnClose}
          >
            {cancelBtn}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    apiError: state.dashboard.apiError
  }
}

export default connect(mapStateToProps, undefined)(Authorization);
